import { AsYouType, CountryCode, getCountryCallingCode, parsePhoneNumber } from 'libphonenumber-js';

export const usePhone = () => {
    const setFormatPhone = (code: string, phone: string, regionCode: CountryCode, maxLength?: number) => {
        try {
            if (!phone) return '';

            const digits = phone.replace(/\D/g, '');

            // Apply extension formatting if maxLength is provided and not the default
            const shouldFormatExtension = maxLength !== undefined && maxLength !== 15;

            if (shouldFormatExtension) {
                const mainNumberDigits = digits.slice(0, 10);
                const extensionDigits = digits.slice(10);

                const number = parsePhoneNumber(mainNumberDigits, regionCode);
                let formattedMain: string;

                if (number.isValid()) {
                    formattedMain = number.format('NATIONAL', { nationalPrefix: false });
                } else {
                    formattedMain = new AsYouType(regionCode).input(mainNumberDigits);
                }

                if (extensionDigits) {
                    return `${formattedMain} x${extensionDigits}`;
                }

                return formattedMain;
            } else {
                // Without extension support
                const number = parsePhoneNumber(digits, regionCode);

                if (number.isValid()) {
                    return number.format('NATIONAL', { nationalPrefix: false });
                } else {
                    return new AsYouType(regionCode).input(digits);
                }
            }
        } catch (error: any) {
            // Fallback: use AsYouType with entire input
            const asYouType = new AsYouType(regionCode);

            return asYouType.input(phone);
        }
    };

    const isPhoneValid = (phone: any, regionCode: any): boolean => {
        try {
            const number = parsePhoneNumber(phone, regionCode);

            return number.isValid();
        } catch (error: any) {
            return false;
        }
    };

    const isGetCountryCallingCode = (regionCode: any): any => {
        try {
            if (regionCode) {
                const countryCallingCode = getCountryCallingCode(regionCode);

                return `+${countryCallingCode}`;
            }
        } catch (error: any) {
            return `+1`;
        }
    };

    const phoneInfo = (phone: string, regionCode: CountryCode) => {
        try {
            return parsePhoneNumber(phone, regionCode);
        } catch (error: any) {
            return false;
        }
    };

    const getCustomFormatPhone = (phone: string, regionCode: CountryCode) => {
        try {
            const info: any = phoneInfo(phone, regionCode);
            const formattedPhoneNumber = setFormatPhone(info.countryCallingCode, info.nationalNumber, info.country);

            return `(+${info.countryCallingCode}) ${formattedPhoneNumber}`;
        } catch (error: any) {
            return false;
        }
    };

    const getFormatPhone = (phone: string, regionCode: CountryCode) => new AsYouType(regionCode).input(phone);

    return {
        setFormatPhone,
        getFormatPhone,
        isPhoneValid,
        phoneInfo,
        getCustomFormatPhone,
        isGetCountryCallingCode,
    };
};
